import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { BrainloperUiModule } from 'brainloper-ui';
import { MaterialModule } from '../../modules/material.module';

// Shared Components
import { SideBarComponent } from './side-bar/side-bar.component';
import { FixedNotificationComponent } from './fixed-notification/fixed-notification.component';
import { HandlerItemsComponent, DialogDetailsList } from './handler-items/handler-items.component';
import { HandlerItemsHeaderComponent } from './handler-items/handler-items-header/handler-items-header.component';
import { HandlerItemsRowComponent } from './handler-items/handler-items-row/handler-items-row.component';
import { DateComponent } from './date/date.component';
import { EquipmentTableComponent } from './tables/equipment-table/equipment-table.component';
import { MapComponent } from './map/map.component';
import { ModalTypesComponent } from './modals-types/modal-types.component';
import { CloseOrderComponent } from './workOrder/close-order/close-order.component';
import { ModalFilesComponent } from './modal-files/modal-files.component';

// Pipes
import { DateFormatPipe } from '../../pipes/date-format.pipe';

// Directives
import { OpenDatepickerOnClickDirective } from '../../directives/open-datepicker-on-click.directive';

const SharedComponents = [
  SideBarComponent,
  FixedNotificationComponent,
  HandlerItemsComponent,
  DialogDetailsList,
  HandlerItemsHeaderComponent,
  HandlerItemsRowComponent,
  DateComponent,
  EquipmentTableComponent,
  MapComponent,
  ModalTypesComponent,
  CloseOrderComponent,
  ModalFilesComponent
];

const SharedPipes = [
  DateFormatPipe
];

const SharedDirectives = [
  OpenDatepickerOnClickDirective
];

@NgModule({
    declarations: [
      ...SharedComponents,
      ...SharedPipes,
      ...SharedDirectives
    ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgbModalModule,
    GoogleMapsModule,
    NgxMaterialTimepickerModule,
    BrainloperUiModule,
    MaterialModule
  ],
  exports: [
    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgbModalModule,
    GoogleMapsModule,
    NgxMaterialTimepickerModule,
    BrainloperUiModule,
    MaterialModule,
    // Components
    ...SharedComponents,
    // Pipes
    ...SharedPipes,
    // Directives
    ...SharedDirectives
  ]
})
export class SharedModule { }
